export default [
  {
    id: 'copy-uuid',
    text: 'Copy UUID',
    icon: 'mdi-image-filter-none',
    _enabled: true
  }
];
